export default __webpack_public_path__ + "static/media/drivers.f630d3b6.png";